export default __webpack_public_path__ + "static/media/logo_viacerta.ad9968bd.png";